import { AlertType } from '@alltrails/types/Alert';

// Alert types shown in the top header button on mobile.
// To surface Caution/Info at the top as well, add AlertType.WARNING and AlertType.INFORMATION here.
export const MOBILE_TOP_ALERT_TYPES = new Set([AlertType.CLOSURE, AlertType.DANGER]);

export const CONDITIONS_SECTION_ID = 'conditions';
export const DESCRIPTION_CHAR_LIMIT = 300;
export const HTT_SECTION_ID = 'htt';
export const NEARBY_TRAILS_SECTION_ID = 'nearby-trails';
export const OVERVIEW_SECTION_ID = 'overview';
export const REVIEWS_SECTION_ID = 'trail-reviews';
export const REVIEWS_COUNT = 30;
export const REVIEWS_COUNT_SM = 5;
export const REVIEWS_LOAD_MORE_COUNT = 10;
export const SEGMENTS_SECTION_ID = 'segments';
